class Bridge {
  // 新开一个tab
  public openNewTab(tabParams: { path: string; title?: string; key?: string }) {
    console.log('openNewTab: ', tabParams);
    tabParams.key = `${tabParams.key || tabParams.path}`;
    window.postMessage({
      source: 'xdragon.bridge',
      payload: {
        event: 'openNewTab',
        tab: tabParams
      }
    });
  }

  // 新开一个页面
  public openNewPage(path: string, query: Record<string, any>) {
    const params = {
      // displayMode: 'ONLY_LOGO',
      ...query
    };
    let url = `${path}?`;
    Object.keys(params).forEach(item => {
      url += `${item}=${params[item]}&`;
    });
    window.open(url, '_blank');
  }

  public replaceTab(view: { path: string; key?: string; meta?: { title: string } }) {
    // const closeName = window.location.pathname;
    view.key = `${view.key || view.path}`;
    window.postMessage({
      source: 'xdragon.bridge',
      payload: {
        event: 'openNewTab',
        tab: view
      }
    });
  }

  // 修改tab标题
  public updateTab(tabParams: { path: string; key?: string; title: string }) {
    console.log('updateTab:', tabParams);
    tabParams.key = (tabParams.key || tabParams.path) ?? ' ';
    window.postMessage({
      source: 'xdragon.bridge',
      payload: {
        event: 'updateTab',
        tab: tabParams
      }
    });
  }

  // 关闭tab
  public closeTab(key: string) {
    console.log('closeTab: ', key);
    window.postMessage({
      source: 'xdragon.bridge',
      payload: {
        event: 'closeTab',
        key: key
      }
    });
  }

  // 关闭所有tab
  public closeAllTab() {
    console.log('closeAllTab');
    window.postMessage({
      source: 'xdragon.bridge',
      payload: {
        event: 'closeAllTab'
      }
    });
  }
}

export default Bridge;
